import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { injectIntl } from 'react-intl';

import LocalisedMessage from 'components/Common/LocalisedMessage';
import Button from 'components/Common/Buttons';

import { redirectToLogout } from 'actions';

class MenuMobile extends React.Component {
  static propTypes = {
    showLogout: PropTypes.bool,
    usePreQualifyingQuestionnaire: PropTypes.bool,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired
    }).isRequired
  };

  static defaultProps = {
    showLogout: false,
    usePreQualifyingQuestionnaire: false
  };

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false
    };
  }

  toggle() { const { isMenuOpen } = this.state; this.setState({ isMenuOpen: !isMenuOpen }); }

  render() {
    const { showLogout, usePreQualifyingQuestionnaire, intl } = this.props;
    const { isMenuOpen } = this.state;
    const homeUrl = intl.formatMessage({ id: 'homeButtonActionUrl', defaultMessage: usePreQualifyingQuestionnaire ? '/' : '/form-selection' });

    return (
      <nav className="menu-mobile">
        <button
          type="button"
          className="menu-icon"
          aria-label={ isMenuOpen ? intl.formatMessage({ id: 'accessibility.menu.close' }) : 'Menu' }
          tabIndex="0"
          onClick={ () => this.toggle() }
        >
          { isMenuOpen && <FontAwesomeIcon icon="times" size="2x" /> }
          { !isMenuOpen && <FontAwesomeIcon icon="bars" size="2x" /> }
        </button>
        <div className={ `mobile-menu-content ${ isMenuOpen ? 'open' : '' }` }>
          <div className="links">
            <a href={ homeUrl } className="btn btn-link" onClick={ () => this.toggle() }>
              <FontAwesomeIcon icon="home" size="lg" />
              {usePreQualifyingQuestionnaire ? <LocalisedMessage id="navbar.home" /> : <LocalisedMessage id="navbar.formSelection" /> }
            </a>
            { showLogout && <Button value="" className="btn-link m-0 text-left" onClick={ () => redirectToLogout() }>
              <FontAwesomeIcon icon="sign-out-alt" size="lg" />
              <LocalisedMessage id="navbar.logout" />
            </Button> }
          </div>
        </div>
      </nav>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    app: {
      onlineConfig
    },
  } = state;

  return {
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MenuMobile));
